import React from "react"; 
import { Link } from "react-router-dom";    
import DealerQuotationForm from "./DealerQuotationForm";
// import CreateBrandForm from "./CreateBrandform";

const CreateDealerQuotation = () => {
  return (
    <>
      {/* Breadcrumb */}
      {/* <div className="breadcrumb-card">
        <h5>Create Quotation</h5>

        <ul className="breadcrumb">
          <li>
            <Link to="/dashboard/ecommerce/">
              <i className="material-symbols-outlined">home</i>
              Dashboard
            </Link>
          </li>
          <li>Create Quotation</li>
        </ul>
      </div> */}

      <DealerQuotationForm />
    </>
  );
};

export default CreateDealerQuotation;
